// Copyright (C) 2020 TANNER AG

import React from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
    root: {
        maxWidth: 450,
        width: "100%",
        marginTop: 30,
    },
    audio: {
        width: "100%",
    },
});

const PodcastsMedia = ({ url, mimeType, classes }) => {
    return (
        <div className={classes.root}>
            {mimeType.indexOf("audio") >= 0 && (
                <audio className={classes.audio} controls>
                    <source src={url} />
                </audio>
            )}
            {mimeType.indexOf("video") >= 0 && (
                <video className={classes.audio} controls>
                    <source src={url} />
                </video>
            )}
        </div>
    );
};

PodcastsMedia.propTypes = {
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    mimeType: PropTypes.string.isRequired,
};

export default compose(withStyles(styles))(PodcastsMedia);



// WEBPACK FOOTER //
// ./src/components/PodcastsMedia.js